module.exports = __webpack_public_path__ + "static/media/mobile-application-security-testing.532e3593.png";